import { useQuery } from '@tanstack/react-query'
import api from '@/api/axiosApi'
import { queryKeys } from '@/lib/queryKeys'
import type { ApiPlanDetailResponse } from '@/types'

/**
 * Fetch plan metadata (owner, dates, etc.) without fetching lines
 */
async function fetchPlanMetadata(
  planId: string
): Promise<ApiPlanDetailResponse> {
  const response = await api.get<ApiPlanDetailResponse>(`/plans/${planId}`)
  return response.data
}

/**
 * Hook for fetching plan metadata (lightweight, no lines)
 */
export function usePlanMetadata(planId: string) {
  return useQuery<ApiPlanDetailResponse>({
    queryKey: queryKeys.planDetail.metadata(planId),
    queryFn: () => fetchPlanMetadata(planId),
    enabled: !!planId,
    staleTime: 30_000, // Cache for 30 seconds
  })
}
